import * as React from 'react';
import { usePromoSelectionEnabled } from '../../hooks/promoOffersSelection';
import { FavoritesFolderContainer } from '../FavoritesFolderContainer';
import { PromoOffersSelection } from '../PromoOffersSelection';

export const PromoOffersContainer = () => {
  const isPromoOffersEnabled = usePromoSelectionEnabled();

  if (!isPromoOffersEnabled) {
    return null;
  }

  return (
    <>
      <PromoOffersSelection />
      <FavoritesFolderContainer />
    </>
  );
};
